// extracted by mini-css-extract-plugin
module.exports = {"enroll":"Enroll_enroll__ahNR4","enroll__btn":"Enroll_enroll__btn__-Urkn","enroll__spinner":"Enroll_enroll__spinner__EyeHb"};